import { escapeHtml, queryIconMarkup } from "../query/presentation.js";
// The API supplies the resolved original ARGB and its source class. This is
// only the browser color-format projection, never a second default palette.
export function titleColorCss(title) {
  const argb = title.color.argb.toString(16).padStart(8, "0");
  return `#${argb.slice(2)}${argb.slice(0, 2)}`;
}

// Verified labels in the original English, German, and Korean descriptions.
// This is a presentation split of one source string, not new source fields.
export function titleDescriptionParts(description) {
  if (description === null) return { condition: null, description: null };
  const match = /^(?:Title Requirement|Title Condition|Voraussetzung|칭호 조건):[ \t]*([^\r\n]*)(?:\r?\n([\s\S]*))?$/.exec(description);
  if (!match) return { condition: null, description };
  return { condition: match[1].trim(), description: match[2] || null };
}


export function titleIdentityMarkup(title) {
  return `<span class="inline-flex items-center gap-1.5" style="color:${titleColorCss(title)}">${queryIconMarkup(title.availability?.obtainable === false ? "ghost-fill" : title.kind === "contest" ? "trophy-fill" : "medal-fill")}<span>${escapeHtml(title.name || String(title.titleId))}</span></span>`;
}

